import createState from '../vl-vendors/state';
import * as getters from '../vl-vendors/getters';
import * as actions from '../vl-vendors/actions';
import * as mutations from '../vl-vendors/mutations';

import {createModule} from 'vuex-loopback';
import model from '@/models/user-model';

export default function ({client, onError, onSuccess}) {

  return {
    namespaced: true,
    ...createModule({
      model,
      client,
      onError,
      onSuccess,
      collection: 'vendors',
      getters,
      actions,
      mutations,
      state: createState(),
    }),
  };
}
